import { useBetterAuthUserStore } from './betterAuthUserStore';

// Compatibility layer: Export the better-auth store as the old name
export const useUserStore = useBetterAuthUserStore;

// Compatibility layer: redirect to better-auth store
export const useMe = () =>
  useBetterAuthUserStore((state) => state.userData?.me);
